import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    display: 'flex',
    position: 'relative',
    width: '100%',
    height: '100vh',
    minHeight: '600px',
    marginTop: '$xl',
})

export const ImageWrapper = styled('div', {
    width: '50%',
    height: '100%',
})

export const VideoWrapper = styled('div', {
    width: 'calc(8 * $colWidth)',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',

    video: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
})

export const Content = styled('div', {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
    textAlign: 'center',

    '@lgDown': {
        width: '80%',
    },
})
